import {LitElement, html, css} from 'lit';
import {connect} from 'pwa-helpers';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../../../store';
import {selectLdt1, selectDimensionHeight, selectDimensionWidth, selectDimensionDepth, selectMountingInstruction} from '../../../selectors';
import {conditional} from '../../../util/conditional';


@customElement('page-diagram-for-light')
export class PageDiagramForLight extends connect(store)(LitElement) {

	static styles = [
		css`
		.page-container {
			display: flex;
			width: 100vw;
			margin-top: 80px;
		}

		.diagrams {
			width: 50vw;
		}

		.description {
			font: var(	--font-specsheet-print-light);
			width: 46vw;
		}

		.downloads {
			margin-top: 50px;
			font: var(--font-specsheet-print-bold);
		}

		a {
			color: #000;
		}

		p {
			font: var(--font-specsheet-print-light);
		}

		p span {
			font: var(--font-specsheet-print-bold);
		}
		.image {
			margin-bottom: 60px;
		}

		.sketch  {
			height: 230px;
		}

		.title {
			color: var(--color-black);
			font-size: var(--font-size-sections);
			font-weight: bold;
		}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = this.state.status.lang;
		this.decisions = state.decisions.data;
		this.conditionalVariantValues = state.productData.conditionalVariantValues;
		this.translations = state.productData.translations;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;
		this.productData = state.productData.productData;
		this.lang = state.status.lang;
	}
	c(id) {
		return conditional(this.decisions, this.conditionalVariantValues, id);
	}
	render() {
		const s = this.state;
		return html`
		<specsheet-light-section>
			<page-header content-title="${msg('Our luminaire recommendation')}" label-choice="light"></page-header>
			<div class="page-container">
				<div class="diagrams">
					<div class="image">
						${when( this.c('REDTAB.RETURN_LE_PolarDiagramP2') && this.c('REDTAB.RETURN_LE_PolarDiagramP2') !=='', () => html`
						<img alt="polar diagram" src="${this.c('REDTAB.RETURN_LE_PolarDiagramP2')}" />
						`)}
					</div>
					<!--<trans-label class="title" slot="title" key="TE_Dimensions" context="D"></trans-label>!-->
					<div slot="content">
						${when( this.c('REDTAB.RETURN_LU_Sketch') && this.c('REDTAB.RETURN_LU_Sketch') !=='', () => html`
						<img class="sketch" alt="sketch" src="${this.c('REDTAB.RETURN_LU_Sketch')}" />
						`)}
						<p>L: ${selectDimensionDepth(s)} mmm, B: ${selectDimensionWidth(s)} mm, H: ${selectDimensionHeight(s)} mm</p>
					</div>
				</div>
				<div class="description">
					<div slot="content">
						<light-tender-text class="light-pdf"></light-tender-text>
						<span class="downloads">Downloads</span>
						${when(selectMountingInstruction(this.state) !== null, () => html`
						<a href="${selectMountingInstruction(this.state)}"
						target="_blank">${msg('Mounting instruction')}</a><br>
						`)}
						${when(selectLdt1(this.state) !== null, () => html`
						<a href="${selectLdt1(this.state)}" target="_blank">${msg('LDT Side')} A</a><br>
						`)}
						<br><br><br>
						<p><span>Nehmen Sie gern für einen persönlichen Austausch und weitere Informationen Kontakt mit uns auf.<br><br>
						E info@selux.de<br>
						T +49 30 72 001 0 </span></p>
					</div>
				</div>
			</div>
			<page-footer></page-footer>
		`;
	}
}
